export const MapMarkerIcon = `<svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 2C41.8544 2 52 9.5 52 21.5C52 29.3182 47.9749 38.3513 40.7586 49.2375L35.6606 56.8085L34.3655 58.6751L32 62L30.0273 59.232L28.3394 56.8085L23.75 50C16.2145 38.7721 12 29.5 12 21.5C12 9.5 22.1456 2 32 2Z"
      fill="#AD1E1F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 29V22.8477H27.3845V29H23ZM22 29V15C22 13.8954 22.8954 13 24 13H40C41.1046 13 42 13.8954 42 15V29H43.5C43.7761 29 44 29.2239 44 29.5C44 29.7761 43.7761 30 43.5 30H42H35.7695V30.0087H34.7695V30H28.3845V30.0089H27.3845V30H22H20.5C20.2239 30 20 29.7761 20 29.5C20 29.2239 20.2239 29 20.5 29H22ZM41 29V22.8477H35.7695V29H41ZM34.7695 29V22.8477H28.3845V29H34.7695Z"
      fill="white"
    />
    <path
      d="M29.769 15.8965V20.8945H30.798V17.3875H30.812L32.037 20.8945H32.884L34.109 17.3525H34.123V20.8945H35.152V15.8965H33.605L32.499 19.3335H32.485L31.316 15.8965H29.769Z"
      fill="#AD1E1F"
    />
  </svg>`
export default MapMarkerIcon
